export default __webpack_public_path__ + "static/media/chevrons-right.0b997a06.svg";